let globalImportStartTime: number | null;
export function getGlobalImportStartTime(): number | null {
    const timeTemp = globalImportStartTime;
    globalImportStartTime = null;
    return timeTemp;
}

export function setGlobalImportStartTime(time: number | null): void {
    globalImportStartTime = time;
}
